import React from 'react';
import PropTypes from 'prop-types';

import { Grid } from '@wds/grid';
import { Typography } from '@wds/typography';
import { Box } from '@wds/box';
import { removeQueryParameters, stripHttp } from '~app/pages/AppsDirectory/components/utils';
import useStyles from '../styles';

export const AppDetailsFooter = ({ appDetails }) => {
  const { footerContainer, footerColumn } = useStyles();
  return (
    <Box className={footerContainer}>
      <Grid noBleeds mb={6}>
        <If condition={appDetails.supportUrl}>
          <Grid.Item sm={5} md={4}>
            <Box className={footerColumn}>
              <Typography variant="cardTitle">Support URL</Typography>
              <Typography variant="body">
                <a href={appDetails.supportUrl}>{appDetails.supportUrl}</a>
              </Typography>
            </Box>
          </Grid.Item>
        </If>
        <If condition={appDetails.supportEmail}>
          <Grid.Item sm={5} md={4}>
            <Box className={footerColumn}>
              <Typography variant="cardTitle">Support Email</Typography>
              <Typography variant="body">
                <a href={`mailto:${appDetails.supportEmail}`}>{appDetails.supportEmail}</a>
              </Typography>
            </Box>
          </Grid.Item>
        </If>
        <If condition={appDetails.supportPhoneNumber}>
          <Grid.Item sm={5} md={4}>
            <Box className={footerColumn}>
              <Typography variant="cardTitle">Support Number</Typography>
              <Typography variant="body">
                <a href={`tel:${appDetails.supportPhoneNumber}`}>{appDetails.supportPhoneNumber}</a>
              </Typography>
            </Box>
          </Grid.Item>
        </If>
        <Grid.Item sm={5} md={4}>
          <Box className={footerColumn}>
            <Typography variant="cardTitle">Privacy</Typography>
            <Typography variant="body">
              <a href={appDetails.privacyPolicyUrl}>{stripHttp(removeQueryParameters(appDetails.privacyPolicyUrl))}</a>
            </Typography>
          </Box>
        </Grid.Item>
        <Grid.Item sm={5} md={4}>
          <Box className={footerColumn}>
            <Typography variant="cardTitle">Terms of service</Typography>
            <Typography variant="body">
              <a href={appDetails.termsOfUseUrl}>{stripHttp(removeQueryParameters(appDetails.termsOfUseUrl))}</a>
            </Typography>
          </Box>
        </Grid.Item>
      </Grid>
    </Box>
  );
};

AppDetailsFooter.propTypes = {
  appDetails: PropTypes.shape({
    publisher: PropTypes.string,
    featureList: PropTypes.arrayOf(PropTypes.string),
    googleAnalyticsTrackingId: PropTypes.string,
    supportEmail: PropTypes.string,
    supportPhoneNumber: PropTypes.string,
    supportUrl: PropTypes.string,
    requirements: PropTypes.arrayOf(PropTypes.string),
    screenshots: PropTypes.arrayOf(PropTypes.string),
    privacyPolicyUrl: PropTypes.string,
    termsOfUseUrl: PropTypes.string,
    blogUrl: PropTypes.string,
    youtubeUrl: PropTypes.string,
    websiteUrl: PropTypes.string,
    installUrl: PropTypes.string,
    upgradeRequired: PropTypes.bool,
    optionalUpgrade: PropTypes.bool,
    scopes: PropTypes.arrayOf(PropTypes.string),
    link: PropTypes.string,
    linkType: PropTypes.string,
  }).isRequired,
};

export default AppDetailsFooter;
